module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-selling deeppur"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "purple-optim"
  }, [_c('div', {
    staticClass: "b"
  }, _vm._l((_vm.b), function(item, index) {
    return (index < 2) ? _c('router-link', {
      key: item.key,
      attrs: {
        "to": item.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "alt": item.aname
      }
    })]) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, _vm._l((_vm.s), function(item, index) {
    return (index < 5) ? _c('router-link', {
      key: item.key,
      attrs: {
        "to": item.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "alt": item.aname
      }
    })]) : _vm._e()
  }), 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mod-selling-title"
  }, [_c('span', [_vm._v("盾盾精选")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a959b5d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/self-owned-mall/index/gd-selected.vue
// module id = 1574
// module chunks = 1